globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Settings = appCustomerSpace.Controllers.Settings || {};

appCustomerSpace.Controllers.Settings.LocationMarketingProfileController = (function(superClass)
{
  utils.extend(LocationMarketingProfileController, superClass);

  function LocationMarketingProfileController() {
    return LocationMarketingProfileController.__super__.constructor.apply(this, arguments);
  }

  $.extend(LocationMarketingProfileController.prototype, {
    init: function() {
      var self = this;

      $(document).on("input", ".multiple-array-input-container .multiple-array-input", function() {
        self.handleInputChange($(this));
      });

      $(document).on("focus", ".multiple-array-input-container .multiple-array-input", function() {
        $(this).closest(".multiple-array-input-item").removeClass("new-input");
      });

      $(document).on("blur", ".multiple-array-input-container .multiple-array-input", function() {
        self.handleBlur($(this));
      });

      $(document).on("click", ".remove-multiple-array-input-item", function(e) {
        e.preventDefault();
        self.handleRemove($(this));
      });

      $(document).on("keydown", ".multiple-array-input-container .multiple-array-input", function(e) {
        if (e.key === "Enter") {
          e.preventDefault();
          self.handleEnter($(this));
        } else if (e.key === "Tab" && !e.shiftKey) {
          self.handleTab($(this), e);
        }
      });

      $(".multiple-array-input-container .remove-multiple-array-input-item:visible").attr("tabindex", "-1");

      $(document).on("click", ".js-generate-targeted-list", function(e) {
        e.preventDefault();
        self.generateTargetedList($(this));
      });

      $(document).on("click", ".js-complete-targeted-profile", function(e) {
        e.preventDefault();
        self.completeTargetedProfile($(this));
      });

      return LocationMarketingProfileController.__super__.init.apply(this, arguments);
    },

    generateTargetedList: function($button) {
      if ($button.prop("disabled")) return;

      var url = $button.data("url");
      $button.prop("disabled", true);

      var $modal = $($(".js-suggestions-loader-template").html().trim());
      var modal = appCustomerSpace.Modal.mountCurrentModal($modal);
      modal.open({});

      $modal.on("hidden.bs.modal", function() {
        $button.prop("disabled", false);
      });

      var handle = appCustomerSpace.StepsLoader.start({
        $container: $modal.find(".js-suggestions-loader"),
        steps: [
          "L'IA analyse votre activité…",
          "L'IA identifie vos clients idéaux…",
          "L'IA détaille chaque profil…",
          "Préparation des suggestions…"
        ],
        minDelayMs: 2500,
        maxDelayMs: 4500,
        loaderOptions: { style: { backdrop: { background: "#fff" } } }
      });

      var fail = function(message) {
        handle.stop();
        modal.close();
        $button.prop("disabled", false);
        new PNotify({ icon: "icon-cross2", title: message || "Une erreur est survenue", type: "error", delay: 3000 });
      };

      $.ajax({
        url: url,
        method: "POST",
        dataType: "json",
        success: function(data) {
          if (data.response === 1) {
            App.cable.subscriptions.create(
              {
                channel: "CustomerSpace::Settings::MarketingProfile::TargetedCustomerProfilesChannel",
                location_uniq_key: data.location_uniq_key
              },
              {
                received: function(payload) {
                  if (payload.action === "suggestions_ready") {
                    handle.stop();
                    $modal.find(".js-suggestions-loader").remove();
                    var $content = $modal.find(".js-suggestions-content");
                    $content.html(payload.html);
                    if (payload.has_suggestions) {
                      $modal.find(".js-suggestions-submit").show();
                    }
                    appCustomerSpace.LimitlessPlugins.initPlugins($content);
                    appCustomerSpace.Plugins.initPlugins($content);
                  } else if (payload.action === "suggestions_failed") {
                    fail();
                  }
                }
              }
            );
          } else {
            fail(data.error);
          }
        },
        error: function() {
          fail();
        }
      });
    },

    completeTargetedProfile: function($button) {
      if ($button.prop("disabled")) return;

      var url = $button.data("url");
      var $container = $button.closest(".panel");
      $button.prop("disabled", true);

      var handle = appCustomerSpace.StepsLoader.start({
        $container: $container,
        steps: [
          "L'IA analyse ce profil…",
          "L'IA rédige douleurs et objectifs…"
        ],
        minDelayMs: 2500,
        maxDelayMs: 4500
      });

      $.ajax({
        url: url,
        method: "POST",
        dataType: "json",
        success: function(data) {
          if (data.response === 1) {
            handle.stop();
            var $newPanel = $(data.html.trim());
            $container.replaceWith($newPanel);
            appCustomerSpace.LimitlessPlugins.initPlugins($newPanel);
            appCustomerSpace.Plugins.initPlugins($newPanel);
          } else {
            handle.stop();
            $button.prop("disabled", false);
            new PNotify({ icon: "icon-cross2", title: data.error || "Une erreur est survenue", type: "error", delay: 3000 });
          }
        },
        error: function() {
          handle.stop();
          $button.prop("disabled", false);
          new PNotify({ icon: "icon-cross2", title: "Une erreur est survenue", type: "error", delay: 3000 });
        }
      });
    },

    getContainerContext: function($element) {
      var $item = $element.closest(".multiple-array-input-item");
      var $container = $item.closest(".multiple-array-input-container");
      var $allItems = $container.find(".multiple-array-input-item");
      return {
        item: $item,
        container: $container,
        allItems: $allItems,
        lastItem: $allItems.last()
      };
    },

    getInputValue: function($input) {
      return $input.val().trim();
    },

    focusInputAtEnd: function($input) {
      $input.focus();
      var length = $input.val().length;
      $input[0].setSelectionRange(length, length);
    },

    toggleRemoveButton: function($item, hasValue) {
      var $button = $item.find(".remove-multiple-array-input-item");
      $item.find(".input-group-btn").toggle(hasValue);
      if (hasValue) {
        $button.attr("tabindex", "-1");
      }
    },

    addNewEmptyInput: function($container) {
      var $template = $container.find("template.multiple-array-input-template");
      if ($template.length) {
        $container.append($($template.html().trim()));
      }
    },

    ensureEmptyInputAtEnd: function(ctx) {
      var $lastInput = ctx.lastItem.find(".multiple-array-input");
      var lastValue = this.getInputValue($lastInput);

      if (lastValue.length > 0) {
        this.addNewEmptyInput(ctx.container);
      } else {
        ctx.lastItem.addClass("new-input");
      }
    },

    removeDuplicateEmptyInput: function(ctx, $currentItem, currentValue) {
      if (currentValue.length > 0 || ctx.allItems.length <= 1) return;

      var currentIndex = ctx.allItems.index($currentItem);
      var isSecondToLast = currentIndex === ctx.allItems.length - 2;
      var lastValue = this.getInputValue(ctx.lastItem.find(".multiple-array-input"));

      if (isSecondToLast && lastValue.length === 0) {
        ctx.lastItem.remove();
        ctx.allItems = ctx.container.find(".multiple-array-input-item");
        ctx.lastItem = ctx.allItems.last();
        if (this.getInputValue(ctx.lastItem.find(".multiple-array-input")).length === 0) {
          ctx.lastItem.addClass("new-input");
        }
      }
    },

    handleInputChange: function($input) {
      var ctx = this.getContainerContext($input);
      var value = this.getInputValue($input);
      var isLast = ctx.item.is(ctx.lastItem);

      this.toggleRemoveButton(ctx.item, value.length > 0);

      if (value.length === 0) {
        this.removeDuplicateEmptyInput(ctx, ctx.item, value);
      }

      if (isLast && value.length > 0) {
        this.addNewEmptyInput(ctx.container);
      }

      if (ctx.item.hasClass("new-input") && value.length > 0) {
        ctx.item.removeClass("new-input");
      }
    },

    handleBlur: function($input) {
      var ctx = this.getContainerContext($input);
      var value = this.getInputValue($input);
      var isLast = ctx.item.is(ctx.lastItem);

      if (value.length === 0 && !isLast && ctx.allItems.length > 1) {
        this.removeLastEmptyInput(ctx);
      }
    },

    handleRemove: function($button) {
      var ctx = this.getContainerContext($button);
      if (ctx.allItems.length <= 1) return;

      this.removeLastEmptyInput(ctx);
    },

    removeLastEmptyInput: function(ctx) {
      ctx.item.remove();
      ctx.allItems = ctx.container.find(".multiple-array-input-item");
      ctx.lastItem = ctx.allItems.last();
      this.ensureEmptyInputAtEnd(ctx);
    },

    handleEnter: function($input) {
      var ctx = this.getContainerContext($input);

      var currentItemIndex = ctx.allItems.index(ctx.item);
      var $nextItem = ctx.allItems.eq(currentItemIndex + 1);

      if ($nextItem.length) {
        var $nextInput = $nextItem.find(".multiple-array-input");
        this.focusInputAtEnd($nextInput);
      } else {
        this.ensureEmptyInputAtEnd(ctx);
        ctx.allItems = ctx.container.find(".multiple-array-input-item");
        var $lastInput = ctx.lastItem.find(".multiple-array-input");
        this.focusInputAtEnd($lastInput);
      }
    },

    handleTab: function($input, e) {
      var ctx = this.getContainerContext($input);
      var $deleteButton = ctx.item.find(".remove-multiple-array-input-item");

      var $allFocusable = $("input, button, select, textarea, a[href], [tabindex]:not([tabindex='-1'])").filter(":visible");
      var currentIndex = $allFocusable.index($input);
      var $nextFocusable = $allFocusable.eq(currentIndex + 1);

      var isDeleteButton = $deleteButton.is(":visible") && $nextFocusable.is($deleteButton);
      var isNextInputInContainer = $nextFocusable.closest(ctx.container).length > 0 && $nextFocusable.hasClass("multiple-array-input");

      if (isDeleteButton || isNextInputInContainer) {
        e.preventDefault();

        var currentItemIndex = ctx.allItems.index(ctx.item);
        var $nextItem = ctx.allItems.eq(currentItemIndex + 1);

        if ($nextItem.length) {
          var $nextInput = $nextItem.find(".multiple-array-input");
          this.focusInputAtEnd($nextInput);
        } else {
          this.ensureEmptyInputAtEnd(ctx);
          ctx.allItems = ctx.container.find(".multiple-array-input-item");
          var $lastInput = ctx.lastItem.find(".multiple-array-input");
          this.focusInputAtEnd($lastInput);
        }
      }
    }
  });

  return LocationMarketingProfileController;

})(appCustomerSpace.Controllers.Settings.MainController);
